import { ref } from 'vue'
import type { OperationResults } from '@/scripts/Common'
import { HttpError } from '@/scripts/Common/api/classes'
import { ErrorCodes } from '@/Enums'

const fetchError = ref<any>(null)
const itemResults = ref<OperationResults<any> | null>(null)

export function useGlobalError() {
  return {
    fetchError,
    itemResults,
    setFetchError: (err: any) => {
      if (err instanceof HttpError && err.problemDetails.type === ErrorCodes.client_session_expired) return;
      fetchError.value = err
    },
    setItemResults: (results: OperationResults<any>) => { itemResults.value = results },
    clearFetchError: () => { fetchError.value = null },
    clearItemResults: () => { itemResults.value = null },
  }
}
